import styled from 'styled-components';

/** Lista vertical de botões de ponto (reutilizável fora do grid 2 col do MissionCard). */
export const StackedMissionPointList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
    padding: 8px 0 4px;
    box-sizing: border-box;
`;
